/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from "react";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      year: "",
    };
  }
  componentDidMount() {
  
    this.date();
  }

  date = () => {
    var year = new Date().getFullYear(); //Current Year
    this.setState({
      year: year,
    });
  };

  render() {
    return (
      <footer className="container-fluid pl-5 pr-5 d-print-none">
        <div className="row">
          <div className="col-6 p-0">
            <p className="text-left">
              All Rights Reserved by
              {/* <a href="javascript:void(0);" target="_blank"> */}
              <a href="#" target="_blank">
                {" "}
                RC Hospitals<sup>TM</sup>
              </a>{" "}
              © {this.state.year}.
            </p>
          </div>
          <div className="col-6 p-0">
            <div className="float-right">
              {/* <div className="col-6 text-right"><p id="progress"></p></div>
                    <div className="col-6 text-right"><button type="button" className="btn btn-info" id = "checkspeedtest">Speed Test</button></div> */}
              <p>
                Designed & Developed By{" "}
                <a href="https://www.auroraelabs.com/" target="_blank">
                  {" "}
                  Aurora e-Labs
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
